export default __webpack_public_path__ + "static/media/eodatabee-cefas.8e5012e9.png";